import { join, o, map, split, compose } from 'ramda';
import { toUpperFirst } from 'ramda-extension';

export const getColumnsQueryString = columns =>
	columns
		? `$columns=${o(join(','), map(compose(join('/'), map(toUpperFirst), split('.'))))(columns)}`
		: null;
